import { createSelector } from 'reselect';

import getSelectors from '../../shared/store/selectorsFactory';
import { adminPageNames } from '../../shared/adminPageNames';

import { decodeCountryTaxTypeForArray } from '../../../utils/encodeDecodeCTT';

export const sharedSelectors = getSelectors(adminPageNames.GL_JOURNALS);

export const glJournalsSelector = ({ administration }) =>
  decodeCountryTaxTypeForArray(administration[adminPageNames.GL_JOURNALS].entities);


export const isFetchingInitialDataForAddAndEditModalSelector = ({ administration }) =>
  administration[adminPageNames.GL_JOURNALS].isFetchingInitialDataForAddAndEditModal;

export const typeOptionsSelector = createSelector(
  ({ administration }) => administration[adminPageNames.GL_JOURNALS].types,
  types => types.map(({ value }) => ({ label: value, value }))
);

export const activityOptionsSelector = createSelector(
  ({ administration }) => administration[adminPageNames.GL_JOURNALS].activities,
  types => types.map(({ value }) => ({ label: value, value }))
);

export const slAccountOptionsSelector = createSelector(
  ({ administration }) => administration[adminPageNames.GL_JOURNALS].slAccounts,
  types => types.map(({ slAccount }) => ({ label: slAccount, value: slAccount }))
);

export const glAccountOptionsSelector = createSelector(
  ({ administration }) => administration.glJournals.glAccounts,
  glAccounts => glAccounts.map(({ glAccount }) => ({ label: glAccount, value: glAccount }))
);

export const slTaxEntriesSelector = ({ administration }) => administration[adminPageNames.GL_JOURNALS].slTaxEntries;
